import { computed, defineComponent } from '@vue/composition-api';
import DateRangePicker from 'vue2-daterange-picker';
import { formatDate, tsFromSlot, dateFormat, getWeekDay, isSameDay } from '@/util/dates';
import { yesterday, dateTzFormat, dateTzUnix, dateFromStart } from '@/util/dates';
export default defineComponent({
    components: {
        DateRangePicker
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        workingTime: {
            type: Array,
            default: () => []
        },
        spacedIds: {
            type: Array,
            default: () => []
        },
        spacesCalendarData: {
            type: Array,
            default: () => []
        }
    },
    setup(props, context) {
        const { emit } = context;
        const date = computed(() => {
            if (!props.value.slotFrom) {
                return {
                    startDate: null,
                    endDate: null
                };
            }
            return {};
        });
        const minDate = yesterday;
        const weekDays = computed(() => globalThis.$moment.weekdaysMin());
        const monthNames = computed(() => globalThis.$moment.months());
        const generateClasses = (classes, date) => formatDate(classes, date, props);
        const dayTimezone = (date, mask) => dateTzFormat(date, globalThis.$timezone, mask);
        const changeMonth = (date) => emit('month', dateTzUnix(date, globalThis.$timezone));
        const changeDates = (dates) => {
            if (isSameDay(dates.startDate, dates.endDate)) {
                const wd = getWeekDay(dates.startDate);
                const wt = props.workingTime.find(el => el.week_day === wd);
                if (wt) {
                    const from = tsFromSlot(wt.open_time, globalThis.$timezone, dateFormat(dates.startDate, 'YYYY-MM-DD'));
                    const to = tsFromSlot(wt.close_time, globalThis.$timezone, dateFormat(dates.endDate, 'YYYY-MM-DD'));
                    emit('input', { slotFrom: from, slotTo: to });
                }
            }
            else {
                emit('input', {
                    slotFrom: dateFromStart(dates.startDate, globalThis.$timezone),
                    slotTo: dateFromStart(dates.endDate, globalThis.$timezone, 1)
                });
            }
        };
        return {
            date,
            minDate,
            monthNames,
            weekDays,
            changeDates,
            changeMonth,
            dayTimezone,
            generateClasses
        };
    }
});
